/*
 *
 * TemplatePreviewPage reducer
 *
 */
import { LOCATION_CHANGE } from 'connected-react-router';
import { mapQuestionsAndGroupsAsNodes } from 'containers/QuestionnairePage/utils';
import { getUpdatedNodes } from './utils';

import {
  FETCH_TEMPLATE_PREVIEW,
  FETCH_TEMPLATE_PREVIEW_ERROR,
  FETCH_TEMPLATE_PREVIEW_SUCCESS,
  CREATE_FROM_TEMPLATE,
  CREATE_FROM_TEMPLATE_ERROR,
  CREATE_FROM_TEMPLATE_SUCCESS,
} from './constants';

const initialState = {
  loading: false,
  creatingSurvey: false,
  template: {},
  nodes: [],
  newSurveyUrl: null,
  fetchedTemplate: false,
};

function templatePreviewPageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEMPLATE_PREVIEW:
      return { ...state, loading: true };
    case CREATE_FROM_TEMPLATE:
      return { ...state, creatingSurvey: true, surveyType: action.surveyType };
    case FETCH_TEMPLATE_PREVIEW_SUCCESS: {
      const { data = {} } = action;
      const { questionnaireTemplate = {} } = data;
      const { ql } = questionnaireTemplate;

      let {
        nodes = [],
        screeningQuestions = [], // eslint-disable-line prefer-const
      } = mapQuestionsAndGroupsAsNodes(questionnaireTemplate);

      nodes = getUpdatedNodes({ nodes, ql });
      return {
        ...state,
        template: data,
        nodes,
        screeningQuestions,
        fetchedTemplate: true,
        loading: false,
      };
    }
    case CREATE_FROM_TEMPLATE_SUCCESS: {
      return { ...state, creatingSurvey: false };
    }
    case FETCH_TEMPLATE_PREVIEW_ERROR:
      return { ...state, error: action.error, loading: false };
    case CREATE_FROM_TEMPLATE_ERROR:
      return { ...state, error: action.error, creatingSurvey: false };
    case LOCATION_CHANGE: {
      // if page is the same (user clicked on link of current page) do not clear data
      // this code depends on the existence of the previousRouterPathnameMiddleware middleware
      // which adds the previousPathname in the LOCATION_CHANGE actions
      if (
        action.payload.previousPathname === action.payload.location.pathname
      ) {
        return state;
      }
      return Object.assign({}, initialState);
    }
    default:
      return state;
  }
}

export default templatePreviewPageReducer;
